import React from "react";
import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function KpiCard({ title, value, subtext, icon: Icon, trend }: any) {
  return (
    <div className="bg-card p-6 rounded-2xl shadow-sm border border-border/50 hover:shadow-lg hover:border-primary/20 transition-all duration-300 flex flex-col justify-between group">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-sm font-medium text-muted-foreground uppercase tracking-wider">{title}</h3>
        <div className="w-10 h-10 rounded-xl bg-primary/5 flex items-center justify-center text-primary group-hover:scale-110 group-hover:bg-primary group-hover:text-primary-foreground transition-all duration-300">
          <Icon className="w-5 h-5" />
        </div>
      </div>
      <div>
        <div className={cn("font-display text-3xl font-bold tracking-tight mb-1", trend === 'down' ? 'text-rose-600' : trend === 'up' ? 'text-emerald-600' : 'text-foreground')}>
          {value}
        </div>
        {subtext && <div className="text-sm text-muted-foreground">{subtext}</div>}
      </div>
    </div>
  );
}
